export class Tax {
    label: string;
    tax: number;
}
